export const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).replace(',', '');
  };

  export const formatToGbIsoDateTime = (dateString) => {
    const parsedDate = new Date(dateString)
    const [day, month, year] = parsedDate.toLocaleDateString('en-GB').split('/');
    const hours = parsedDate.getHours().toString().padStart(2, '0');
    const minutes = parsedDate.getMinutes().toString().padStart(2, '0');
    const seconds = parsedDate.getSeconds().toString().padStart(2, '0');
    
    // Build ISO 8601 string with local time
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${hours}:${minutes}:${seconds}`;
  };

  export const formatGBDatestringToGBIsoDateTime = (dateString) => {
    if (dateString === null || dateString === undefined || dateString === '') {
      return null;
    }

    // Handle formats like 'DD/MM/YYYY' or 'DD/MM/YYYY HH:mm[:ss]'
    if (dateString.indexOf('/') > -1) {
      const parts = dateString.split(' ');
      const datePart = parts[0];
      const timePart = parts[1] || '00:00:00';
      const [day, month, year] = datePart.split('/');
      const timeNormalized = timePart.length === 5 ? `${timePart}:00` : timePart;
      return new Date(`${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${timeNormalized}`);
    }

    // If it's already ISO-like or contains a T, let Date parse it
    if (dateString.indexOf('T') > -1 || dateString.indexOf('-') > -1) {
      // Normalize space-separated datetime to ISO
      const normalized = dateString.includes(' ') && !dateString.includes('T') ? dateString.replace(' ', 'T') : dateString;
      const parsed = new Date(normalized);
      return isNaN(parsed.getTime()) ? null : parsed;
    }

    // Fallback: try Date constructor
    const parsed = new Date(dateString);
    return isNaN(parsed.getTime()) ? null : parsed;

  }

  // Helper function: convert a Date into a comparable YYYYMMDDhhmmss number. Hours/minutes/seconds 
  // default to 00 when not supplied, ensuring inclusive comparisons. The multipliers in the return
  // shift the numbers left by the specified number of digits, so the year is followed by ten zeros,
  // month by eight zeros, etc., allowing for straightforward numeric comparison.
  export const convertDateValueToNumber = (d) => {
      const year = d.getFullYear();
      const month = d.getMonth() + 1;
      const day = d.getDate();
      const hour = d.getHours() || 0;
      const minute = d.getMinutes() || 0;
      const second = d.getSeconds() || 0;
      return (
          year * 1e10 +
          month * 1e8 +
          day * 1e6 +
          hour * 1e4 +
          minute * 1e2 +
          second
      );
  };

  // Format a date value for display in CSV exports: dd/mm/yyyy hh:mm:ss (UTC)
  export const formatForCsvDisplay = (dateValue) => {
      if (!dateValue) return '';
      const date = new Date(dateValue);
      if (isNaN(date.getTime())) return '';
      const pad = n => String(n).padStart(2, '0');
      return `${pad(date.getUTCDate())}/${pad(date.getUTCMonth() + 1)}/${date.getUTCFullYear()} ${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}:${pad(date.getUTCSeconds())}`;
  };

  // Strip milliseconds and trailing Z from an ISO timestamp
  export const stripMilliseconds = (dateString) => {
      if (!dateString) return dateString;
      const d = new Date(dateString);
      d.setMilliseconds(0);
      return d.toISOString().replace(/\.000Z$/, '');
  };

  // Format a date to ISO 8601 format with Z suffix, removing milliseconds (YYYY-MM-DDTHH:MM:SSZ)
  export const formatDateForStorage = (date) => {
      if (!date) return null;
      const iso = date instanceof Date ? date.toISOString() : new Date(date).toISOString();
      return iso.replace(/\.\d{3}Z$/, 'Z');
  }; 

    // Generates an array of ISO date strings for the last 28 days, starting with 27 days ago and ending 
    // with today. This is used for local data in the storm widgets to ensure that the xAxis dates/labels 
    // and series timeRangeStart values remain consistent with the current date whenever the local data 
    // is fetched.
    export const generateLast28DaysArray = () => {
      const dates = [];
      const todayUtc = new Date();
      const endDate = new Date(Date.UTC(todayUtc.getUTCFullYear(), todayUtc.getUTCMonth(), todayUtc.getUTCDate()));

      for (let offset = 27; offset >= 0; offset--) {
        const d = new Date(endDate);
        d.setUTCDate(endDate.getUTCDate() - offset);

        const year = d.getUTCFullYear();
        const month = String(d.getUTCMonth() + 1).padStart(2, '0');
        const day = String(d.getUTCDate()).padStart(2, '0');

        dates.push(`${year}-${month}-${day}T00:00:00.0000000Z`);
      }

      return dates;
    };

